"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeInfoPanelStyling = function () {
    var _a, _b, _c, _d;
    var _e = (0, react_1.useTheme)(), mvf = _e.mvf, breakpoints = _e.breakpoints;
    var palette = mvf.palette, fontSize = mvf.fontSize, typography = mvf.typography, spacing = mvf.spacing;
    return {
        panel: (0, react_1.css)((_a = {
                backgroundColor: palette.background.secondaryBackgroundColor,
                color: palette.text.secondaryTextColor,
                paddingRight: spacing.small,
                paddingLeft: spacing.small,
                paddingTop: spacing.tiny,
                paddingBottom: spacing.tiny
            },
            _a[breakpoints.up('mobileLarge')] = {
                paddingTop: spacing.small,
                paddingBottom: spacing.small,
                paddingRight: spacing.medium,
                paddingLeft: spacing.medium,
            },
            _a.borderRadius = 4,
            _a.width = '100%',
            _a.display = 'flex',
            _a.flexDirection = 'row',
            _a)),
        iconBox: (0, react_1.css)((_b = {
                width: '40px',
                flex: '0 0 40px',
                paddingRight: spacing.small
            },
            _b[breakpoints.up('mobileLarge')] = {
                width: '60px',
                flex: '0 0 60px',
                paddingRight: spacing.medium,
            },
            _b.display = 'flex',
            _b.flexFlow = 'column nowrap',
            _b.justifyContent = 'center',
            _b.alignItems = 'center',
            _b.img = {
                width: '100%',
                height: 'auto',
            },
            _b)),
        textBox: (0, react_1.css)({
            width: '100%',
        }),
        title: (0, react_1.css)((_c = {
                fontSize: fontSize.small
            },
            _c[breakpoints.up('mobileMedium')] = {
                fontSize: fontSize.compact,
            },
            _c[breakpoints.up('tabletSmall')] = {
                fontSize: fontSize.medium,
            },
            _c[breakpoints.up('tabletMedium')] = {
                fontSize: fontSize.swoll,
            },
            _c[breakpoints.up('desktopSmall')] = {
                fontSize: fontSize.large,
            },
            _c[breakpoints.up('desktopMedium')] = {
                fontSize: fontSize.big,
            },
            _c.fontWeight = typography.weight.thick,
            _c)),
        children: (0, react_1.css)((_d = {
                fontSize: fontSize.little
            },
            _d[breakpoints.up('tabletSmall')] = {
                fontSize: fontSize.mini,
            },
            _d[breakpoints.up('desktopSmall')] = {
                fontSize: fontSize.small,
            },
            _d['& a'] = {
                color: mvf.palette.text.primaryTextColor,
            },
            _d)),
    };
};
exports.default = makeInfoPanelStyling;
//# sourceMappingURL=makeInfoPanelStyling.js.map